import React from "react";

const Contact = () => {
  return (
    <div className="container mx-auto py-10">
      <h2 className="text-3xl font-bold text-center mb-6">Contact Us</h2>
      <p className="text-lg text-gray-700 text-center">
        Have questions? Reach out to us at info@quickfitapp.com and we’ll be happy to help.
      </p>
    </div>
  );
};

export default Contact;
